






























































































import { ShipmentSearchFilters } from "@/model/component.model";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { required } from "vuelidate/lib/validators";

@Component({
  validations: {
    internalDateStart: {
      required
    },
    internalDateEnd: {
      required
    }
  }
})
export default class ShipmentDate extends Vue {
  @Prop() filters: ShipmentSearchFilters;

  rerenderKey = 0;
  internalOnlyFutureDates = false;
  defaultDateStart: Date;
  internalDateStart: Date;
  defaultDateEnd: Date;
  internalDateEnd: Date;

  get dateStartPickerOptions() {
    return {
      disabledDate: (date: Date) => {
        return date >= this.internalDateEnd;
      },
      firstDayOfWeek: 1
    };
  }

  get dateEndPickerOptions() {
    return {
      disabledDate: (date: Date) => {
        return date < this.internalDateStart;
      },
      firstDayOfWeek: 1
    };
  }

  created() {
    this.resetState();
  }

  resetState() {
    this.defaultDateEnd = new Date();
    this.defaultDateStart = new Date(
      this.defaultDateEnd.getFullYear(),
      this.defaultDateEnd.getMonth(),
      this.defaultDateEnd.getDate() - 30
    );
    this.internalDateStart = this.defaultDateStart;
    this.internalDateEnd = this.defaultDateEnd;
    this.internalOnlyFutureDates = false;
    this.$nextTick(() => this.rerenderComponent());
  }

  rerenderComponent() {
    this.rerenderKey++;
  }

  datesChangeHandler() {
    this.$emit("datesChanged", {
      dateStart: this.internalDateStart,
      dateEnd: this.internalDateEnd
    });
    this.rerenderComponent();
  }

  resetDate(dateType) {
    dateType === "start" && (this.internalDateStart = null);
    dateType === "end" && (this.internalDateEnd = null);
    this.datesChangeHandler();
  }

  onOnlyFutureDatesChange() {
    this.$emit("onlyFutureDatesChanged", this.internalOnlyFutureDates);

    if (this.internalOnlyFutureDates) {
      this.$emit("datesChanged", {
        dateStart: new Date(),
        dateEnd: null
      });
    } else {
      this.$emit("datesChanged", {
        dateStart: this.internalDateStart,
        dateEnd: this.internalDateEnd
      });
    }
  }
}
